const SITE = {
  name: 'Wownautic',
  alternateName: 'WOW Nautic',
  phone: '+34 683 17 17 17',
  email: 'info@wownautic.com',
  streetAddress: 'Puerto Deportivo de Fuengirola, Local 45',
  postalCode: '29640',
  addressLocality: 'Fuengirola',
  addressRegion: 'Málaga',
  addressCountry: 'ES',
  geoLat: 36.5423,
  geoLng: -4.6244,
  sameAs: [
    'https://www.instagram.com/wow_nautic/',
    'https://www.facebook.com/p/WOW-Nautic-Boat-and-Jet-Ski-Rentals-61576095742020/',
    'https://maps.app.goo.gl/fuengirola-marina',
  ],
};

export function buildOrganizationSchema(origin) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE.name,
    alternateName: SITE.alternateName,
    url: origin,
    logo: `${origin}/logo192.png`,
    email: SITE.email,
    telephone: SITE.phone,
    sameAs: SITE.sameAs,
  };
}

export function buildLocalBusinessSchema(origin, reviewStats = {}) {
  const rating = Number(reviewStats.rating) || 5;
  const reviewCount = Number(reviewStats.review_count) || 0;
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: SITE.name,
    alternateName: SITE.alternateName,
    url: origin,
    image: `${origin}/logo192.png`,
    telephone: SITE.phone,
    email: SITE.email,
    priceRange: '€€',
    openingHours: 'Mo-Su 10:00-20:00',
    address: {
      '@type': 'PostalAddress',
      streetAddress: SITE.streetAddress,
      addressLocality: SITE.addressLocality,
      addressRegion: SITE.addressRegion,
      postalCode: SITE.postalCode,
      addressCountry: SITE.addressCountry,
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: SITE.geoLat,
      longitude: SITE.geoLng,
    },
    sameAs: SITE.sameAs,
  };
  if (reviewCount > 0) {
    schema.aggregateRating = {
      '@type': 'AggregateRating',
      ratingValue: rating,
      reviewCount,
      bestRating: 5,
      worstRating: 1,
    };
  }
  return schema;
}

export function buildFaqPageSchema(faqItems) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map(({ q, a }) => ({
      '@type': 'Question',
      name: q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: a,
      },
    })),
  };
}

export function buildBreadcrumbSchema(origin, items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.path.startsWith('http') ? item.path : `${origin}${item.path}`,
    })),
  };
}

export function buildOfferProductSchema({
  origin,
  canonicalPath,
  title,
  description,
  image,
  priceEuros,
  reviewStats = {},
  offerType,
  durationMinutes,
}) {
  const schemaType =
    String(offerType || '').toLowerCase() === 'tour' ? 'TouristTrip' : 'Product';
  const schema = {
    '@context': 'https://schema.org',
    '@type': schemaType,
    name: title,
    description: description || title,
    url: `${origin}${canonicalPath}`,
    brand: {
      '@type': 'Brand',
      name: SITE.name,
    },
    offers: {
      '@type': 'Offer',
      price: priceEuros > 0 ? String(priceEuros) : undefined,
      priceCurrency: 'EUR',
      availability: 'https://schema.org/InStock',
      url: `${origin}${canonicalPath}`,
    },
  };
  if (image) {
    schema.image = image;
  }
  if (durationMinutes > 0 && schemaType === 'TouristTrip') {
    schema.itinerary = {
      '@type': 'ItemList',
      name: `${durationMinutes} min experience`,
    };
  }
  const reviewCount = Number(reviewStats.review_count) || 0;
  if (reviewCount > 0) {
    schema.aggregateRating = {
      '@type': 'AggregateRating',
      ratingValue: Number(reviewStats.rating) || 5,
      reviewCount,
      bestRating: 5,
      worstRating: 1,
    };
  }
  return schema;
}

export function buildHomepageSchemas(origin, faqItems, reviewStats) {
  return [
    buildOrganizationSchema(origin),
    buildLocalBusinessSchema(origin, reviewStats),
    buildFaqPageSchema(faqItems),
  ];
}
